import BaseService from '@/api/services/index'
import Connection from '@/api/models/Connection'
import { BaseResponse } from '@/api/models/BaseResponse'

export default class ConnectionService extends BaseService {
    public async getConnection (): Promise<Connection> {
        const result = await this.api.get<undefined, BaseResponse<Connection>>(
            this.getUrl('connection_get')
        )

        return result.data.data
    }
}
